import { render, staticRenderFns } from "./TagItems.vue?vue&type=template&id=6de29757&scoped=true&"
import script from "./TagItems.vue?vue&type=script&lang=js&"
export * from "./TagItems.vue?vue&type=script&lang=js&"
import style0 from "./TagItems.vue?vue&type=style&index=0&id=6de29757&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de29757",
  null
  
)

export default component.exports